import React from "react";

import { RoleRequestStatusIndicator } from "@src/components/role_request_status_indicator";
import { ROLES } from "@src/constants";
import { RoleRequestNotificationBar } from "@src/features/role_request_details/components/role_request_notification_bar";
import { StaffingRequestNotificationBar } from "@src/features/staffing_request_details/components/staffing_request_notification_bar";
import { Col, Row } from "antd";
import "./role_request_modal_header.less";

interface RoleRequestModalHeaderProps {
  requestId: number;
  requestStatus: string;
  standardRoleName: string;
  isRequestOutdated: boolean;
  userRole?: typeof ROLES.TEAM_LEAD | typeof ROLES.PROJECT_LEAD;
}

const RoleRequestModalHeader: React.FC<
  Partial<RoleRequestModalHeaderProps>
> = ({
  requestId,
  requestStatus,
  standardRoleName,
  isRequestOutdated,
  userRole,
}) => {
  const status = isRequestOutdated ? "Outdated" : requestStatus;

  return (
    <>
      <Row className="role-request-modal-header">
        <Col className="role-request-modal-header__indicator">
          <RoleRequestStatusIndicator size="large" status={status} />
        </Col>
        <Col>
          <div className="role-request-modal-header__title">
            {status} - {requestId} - {standardRoleName}
          </div>
        </Col>
      </Row>
      <Row className="role-request-modal-header__notification">
        {userRole === ROLES.TEAM_LEAD ? (
          <StaffingRequestNotificationBar requestId={requestId} />
        ) : (
          <RoleRequestNotificationBar requestId={requestId} />
        )}
      </Row>
    </>
  );
};

export default RoleRequestModalHeader;
